import React from 'react';
import { NavLink } from 'react-bootstrap';
import { trans } from '../utils';
import CreateButton from './CreateButton';
import UploadExcelButton from './UploadExcelButton';
import UploadExcelModal from './UploadExcelModal';

const HeaderContent = ({ GetModuleData, data, SystemUrl, ComponentToRender }) => {
    return (
        <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
            <div className="subheader py-2 py-lg-6  subheader-transparent " id="kt_subheader">
                <div className=" container-fluid  d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                    <div className="d-flex align-items-center flex-wrap mr-1">
                        <div className="d-flex align-items-baseline flex-wrap mr-5">
                            <h5 className="text-dark font-weight-bold my-1 mr-5">{trans(GetModuleData.name_en)}</h5>
                            <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2 font-size-sm">
                                <li className="breadcrumb-item text-muted">
                                    <NavLink to='/dashboard' className="text-muted">
                                        {trans('Dashboard')}
                                    </NavLink>
                                </li>
                                <li className="breadcrumb-item text-muted">
                                    {trans(GetModuleData.name_en)}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        {!!GetModuleData.add && !!GetModuleData.page_add && data.getaction !== 'Add' ?
                            <div className="d-flex align-items-center py-1">
                                <CreateButton data={trans(data) }GetModuleData={trans(GetModuleData)}/>
                                <UploadExcelButton data={trans(data) } GetModuleData={GetModuleData}/>
                            </div>
                            : <br />
                        }
                    </div>
                    <UploadExcelModal data={trans(data) } GetModuleData={GetModuleData}/>
                </div>
            </div>
            <div className="d-flex flex-column-fluid">
                <div className="container"> 
                    <ComponentToRender RoleId={GetModuleData.role_id} CurrentModule={data.getmodule} SystemUrl={SystemUrl}/>
                </div>
            </div>
        </div>
    );
}

export default HeaderContent;
